export default __webpack_public_path__ + "static/media/kk.59335dd3.jpg";